export default __webpack_public_path__ + "img/recyclable-equipment.0.asset.383ad40d.jpg";